import { render, staticRenderFns } from "./receipt-view.vue?vue&type=template&id=0cf10b96&scoped=true"
import script from "./receipt-view.vue?vue&type=script&lang=ts"
export * from "./receipt-view.vue?vue&type=script&lang=ts"
import style0 from "./receipt-view.vue?vue&type=style&index=0&id=0cf10b96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf10b96",
  null
  
)

export default component.exports